"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductColorModeContext = void 0;

var React = __importStar(require("react"));

var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

exports.ProductColorModeContext = React.createContext({
  productMode: 'luxse',
  toggleProductMode: utils_1.noop,
  colorMode: 'light',
  toggleColorMode: utils_1.noop
});

if (utils_1.isDev) {
  exports.ProductColorModeContext.displayName = 'ProductColorModeContext';
}